export default function Filters() {
  const subPageLoadFiltersHeader = document.querySelector('.sub-page-load-dropdown .dropdown-head');
  const subPageloadFiltersItems = document.querySelectorAll('.sub-page-load-dropdown .body-item');

  const loadFiltersHeaders = document.querySelectorAll('.page-load-dropdown .dropdown-head');
  const loadFiltersItems = document.querySelectorAll('.page-load-dropdown .body-item');

  if (loadFiltersItems && loadFiltersHeaders) {
    loadFiltersItems.forEach((dropItem) => {
      dropItem.addEventListener('click', function onFiltering() {
        const itemHeader = this.closest('.dropdown-item').querySelector('.dropdown-head');
        itemHeader.dataset.filterid = this.dataset.itemid;
        let getURL = '?';
        loadFiltersHeaders.forEach((headerItem) => {
          if (headerItem.dataset.filterid && headerItem.dataset.filterid !== '-1') {
            getURL += `${headerItem.dataset.filtertype}=${headerItem.dataset.filterid}&`;
          }
        });
        getURL = getURL.substring(0, getURL.length - 1);
        if (getURL) {
          window.location = getURL;
        } else {
          window.location = '?';
        }
      });
    });
  }

  if (subPageloadFiltersItems && subPageLoadFiltersHeader) {
    subPageloadFiltersItems.forEach((dropItem) => {
      dropItem.addEventListener('click', function onFiltering() {
        let getURL = '?';
        if (loadFiltersHeaders) {
          loadFiltersHeaders.forEach((headerItem) => {
            if (headerItem.dataset.filterid && headerItem.dataset.filterid !== '-1') {
              getURL += `${headerItem.dataset.filtertype}=${headerItem.dataset.filterid}&`;
            }
          });
        }
        getURL = getURL.substring(0, getURL.length - 1);
        const { slug } = this.dataset;
        if (slug) {
          window.location = `/book/${slug}${getURL}`;
        } else {
          window.location = `/book${getURL}`;
        }
      });
    });
  }
}
